import axios from 'axios'
import router from '../router'
// import md5Hash from './md5.js'
import store from '../store'

const version = '0.0.0.20231212'

axios.defaults.timeout = 5000
axios.defaults.baseURL = process.env.VUE_APP_API_URL1 + '/api'
// var baseURL = process.env.VUE_APP_API_URL + '/api/User/'
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
axios.interceptors.request.use(
  config => {
    // config.data = JSON.stringify(config.data)
    config.headers = { // 如果沒有cors的問題則可以都不加
      'Access-Control-Allow-Origin': process.env.VUE_APP_API_URL1,
      'Access-Control-Allow-Methods': 'GET, PUT, POST, DELETE, OPTIONS',
      'Access-Control-Max-Age': '86400',
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + getToken(),
      // Authorization: 'Bearer ' + getCookie('token'),
      Version: version,
      'Accept-Language': store.state.lang
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  (response) => {
    if (response.status === 202) {
      // 即將過期
      // getNewToken()
      // logout()
    }
    if (response.data.code === 325) {
      //
    } else if (response.data.code === 401) {
      // 避免在登出失敗時，重複呼叫 logout
      if (response.request.responseURL.indexOf('/user/logout') < 0) {
        logout()
        console.log('Token 過期')
      }
    }
    return response
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 401:
          // 避免在登出失敗時，重複呼叫 logout
          if (err && err.response && err.response.request.responseURL.indexOf('/user/logout') < 0) {
            logout()
            console.log('Token 過期')
          }
          // alert('Token 過期')
          // if (outsideCB) {
          //   outsideCB()
          // }
          break
        case 404:
          // console.log('找不到該頁面')
          // alert('找不到該頁面')
          break
        case 500:
          // console.log('伺服器出錯')
          // alert('伺服器出錯')
          break
        case 503:
          // console.log('服務失效')
          // alert('服務失效')
          break
        default:
          // console.log(`連接錯誤${err.response.status}`)
          alert('連接錯誤')
      }
    } else {
      alert('連接到服務器失敗')
      // console.log('連接到服務器失敗')
    }
    return Promise.resolve(err.response)
  }
)

export default {
  getVierificationCode,
  login,
  logout,
  getNavbar,
  getPageData,
  getDictionary,
  uploadImage,
  uploadFile,
  deleteData,
  updateData,
  updatePermission,
  addData,
  setPassword,
  getDetailData,
  forgetPassword,
  changePwd,
  exportFile,
  getBase64File,
  GetLiveViewUrl
}

function getVierificationCode () {
  return new Promise((resolve) => {
    axios.get('/User/getVierificationCode')
      .then(response => {
        // console.log(response)
        resolve(response)
      })
  })
}

function logout () {
    axios({
      method: 'post',
      url: '/user/logout',
      data: { }
    }).then(() => {})

  router.push('/Login')
  store.commit('logout')
  window.location.href = '/Login?t=' + new Date().getTime()
}

function login (parm) {
  return new Promise((resolve,) => {
    // var url = ''
    // psw = encrypt.encrypt(parm.psw.toString(), true)
    axios({
      method: 'post',
      url: '/user/login',
      data: {
        UserName: parm.user,
        Password: parm.psw,
        UUID: parm.uuid,
        VerificationCode: parm.verification
      }
    })
      .then(response => {
        if (response.status === 200 && response.data.status) {
          sessionStorage.setItem('token', response.data.data.token)
          document.cookie = 'token=' + response.data.data.token
          // console.log(getCookie('token'))
          // localStorage.setItem('token', response.data.data.token)
        }
        resolve(response)
      })
  })
}

function changePwd (PWD, USERID) {
  return new Promise((resolve) => {
    axios({
      method: 'post',
      url: '/USERS/ModifyPWD',
      data: {
        extra: null,
        delKeys: null,
        detailData: null,
        mainData: {
          PWD: PWD,
          USERID: USERID
        }
      },
      timeout: 0
    })
      .then(response => {
        // console.log(response)
        resolve(response)
      })
  })
}

function getToken () {
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  var token = ''
  if (isSafari) {
    token = getCookie('token')
  } else {
    token = sessionStorage.getItem('token')
  }
  return token
}

function getCookie (cname) {
  var name = cname + '='
  var ca = document.cookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i].trim()
    if (c.indexOf(name) === 0) return c.substring(name.length, c.length)
  }
  return ''
}

function getNavbar () {
  return new Promise((resolve, ) => {
    axios({
      method: 'post',
      url: '/menu/getTreeMenu',
      data: {}
    })
      .then(response => {
        // console.log(response)
        resolve(response)
      })
  })
}

function exportFile (parm, timeout = 0) {
  return new Promise((resolve, ) => {
    axios({
      method: 'post',
      url: '/' + parm.url,
      responseType: 'blob',
      data: {
        wheres: parm.wheres,
        order: parm.order,
        sort: parm.sort,
        Export: true
      },
      timeout: timeout
    })
      .then(response => {
        // console.log(response)
        resolve(response)
      })
  })
}

function setPassword (parm) {
  //parm.OldPassword = encrypt.encrypt(parm.OldPassword.toString(), true)
  //parm.NewPassword = encrypt.encrypt(parm.NewPassword.toString(), true)
  return new Promise((resolve,) => {
    axios({
      method: 'post',
      url: '/USERS/SetPassword',
      data: {
        extra: parm.extra,
        delKeys: null,
        detailData: parm.detailData,
        mainData: parm
      },
    })
      .then(response => {
        // console.log(response)
        resolve(response)
      })
  })
}

function getPageData (parm, all = false) {
  return new Promise((resolve, ) => {
    axios({
      method: 'post',
      url: '/' + parm.url,
      data: {
        page: parm.page,
        rows: parm.rows,
        sort: parm.sort,
        order: parm.order,
        wheres: parm.wheres,
        export: all
      },
      timeout: 0
    })
      .then(response => {
        // console.log(response)
        resolve(response)
      })
  })
}

function getDictionary (parm) {
  return new Promise((resolve,) => {
    axios({
      method: 'post',
      url: '/Sys_Dictionary/GetVueDictionary',
      data: parm,
      timeout: 0
    })
      .then(response => {
        resolve(response)
      })
  })
}

function getBase64File (url, parm, extra) {
  return new Promise((resolve,) => {
    axios({
      method: 'post',
      url: url,
      data: {
        extra: extra,
        mainData: {
          id: parm
        }
      },
      timeout: 0
    })
      .then(response => {
        resolve(response)
      })
  })
}

function uploadImage (parm, url) {
  return new Promise((resolve) => {
    axios({
      method: 'post',
      url: url,
      data: parm,
      timeout: 0
    })
      .then(response => {
        resolve(response)
      })
  })
}

function uploadFile (parm, url) {
  return new Promise((resolve) => {
    axios({
      method: 'post',
      url: url,
      data: parm,
      timeout: 0
    })
      .then(response => {
        resolve(response)
      })
  })
}

function updateData (parm, url) {
  return new Promise((resolve) => {
    axios({
      method: 'post',
      url: url,
      data: {
        extra: parm.extra,
        delKeys: null,
        detailData: parm.detailData,
        mainData: parm
      },
      timeout: 0
    })
      .then(response => {
        // console.log(response)
        resolve(response)
      })
  })
}

function updatePermission (parm, url) {
  return new Promise((resolve) => {
    axios({
      method: 'post',
      url: url,
      data: parm,
      timeout: 0
    })
      .then(response => {
        // console.log(response)
        resolve(response)
      })
  })
}

function addData (parm, url) {
  return new Promise((resolve) => {
    axios({
      method: 'post',
      url: url,
      data: {
        extra: parm.extra,
        delKeys: null,
        detailData: null,
        mainData: parm
      },
      timeout: 0
    })
      .then(response => {
        // console.log(response)
        resolve(response)
      })
  })
}

function getDetailData (parm, url) {
  return new Promise((resolve) => {
    axios({
      method: 'post',
      url: url,
      data: {
        extra: parm.extra,
        delKeys: null,
        detailData: null,
        mainData: parm
      },
      timeout: 0
    })
      .then(response => {
        // console.log(response)
        resolve(response)
      })
  })
}

function deleteData (parm, url) {
  // console.log(parm)
  return new Promise((resolve) => {
    axios({
      method: 'post',
      url: url,
      data: parm
    })
      .then(response => {
        // console.log(response)
        resolve(response)
      })
  })
}

function forgetPassword (parm, url) {
  return new Promise((resolve) => {
    axios({
      method: 'post',
      url: url,
      data: {
        extra: '',
        delKeys: null,
        detailData: null,
        mainData: parm
      },
      timeout: 0
    })
      .then(response => {
        // console.log(response)
        resolve(response)
      })
  })
}

function GetLiveViewUrl (parm) {
  return new Promise((resolve) => {
    axios({
      method: 'post',
      url: '/site_info/GetLiveViewUrl',
      data: {
        extra: '',
        delKeys: null,
        detailData: null,
        mainData: parm
      },
      timeout: 0
    })
      .then(response => {
        // console.log(response)
        resolve(response)
      })
  })
}
